import { useState } from "react";
import SectionHeader from "./SectionHeader";

const FAQS = [
  {
    q: "小秘漫画网的推荐是怎么选出来的？",
    a: "每一部作品都由编辑部成员完整阅读后，从故事立意、画风表现、节奏把控与情绪共鸣四个维度打分，再结合书友反馈综合筛选，确保推荐有据可依。",
  },
  {
    q: "推荐的漫画在哪里可以阅读？",
    a: "我们只负责帮你挑出值得一读的作品，并在每部作品的推荐卡片中标注题材与特点。具体阅读渠道请以官方正版平台为准，我们始终倡导支持正版。",
  },
  {
    q: "为什么有些「冷门佳作」我搜不到热度？",
    a: "这正是「秘书严选」栏目的意义所在——它们往往被流量淹没，却拥有极高的完成度。我们会用详细的推荐语说明它值得读在哪里，避免你踩坑浪费时间。",
  },
  {
    q: "网站上的评分靠谱吗？",
    a: "评分综合了编辑部精读体验与书友打分，相对稳定但并非绝对权威。不同题材的口味差异很大，建议把评分当作参考，结合推荐语判断是否合你胃口。",
  },
  {
    q: "每日精选一般几点更新？",
    a: "每日精选通常在早上 9 点前更新，周末与节假日也照常更新。你随时回来都能看到当天的选题与搭配，也可以按题材分类快速浏览全部精选。",
  },
  {
    q: "我可以投稿推荐自己喜欢的漫画吗？",
    a: "当然可以。欢迎通过页面底部的联系方式把你的心头好发给我们，编辑部会认真阅读并评估，优质推荐有机会进入正式的推荐栏目。",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="常见问题" className="bg-background-50">
      <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="常见问题"
          eyebrowTone="accent"
          title="你可能想问的"
          subtitle="关于小秘漫画网怎么选书、怎么更新、怎么互动，这里都有答案。"
          align="center"
        />

        <div className="flex flex-col gap-3">
          {FAQS.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-accent-300 bg-background-100" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? "bg-accent-500 text-background-50 rotate-45" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className="ri-add-line" aria-hidden="true"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}